;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputYesNoController', InputYesNoController)

  /* @ngInject */
  function InputYesNoController ($scope) {
    $scope.selectedOption = ''

    activate()

    function activate () {
      const compare = (a, b) => {
        if (a.label.toUpperCase() > b.label.toUpperCase()) return 1
        else return -1
      }

      $scope.options = $scope.options.sort(compare) // ajuste no array, por vezes invertia a ordem

      if (!$scope.value) {
        return
      }
      $scope.selectedOption = $scope.options.find(option => option.value === $scope.value)
    }

    $scope.handleOptionClick = function (option) {
      $scope.model = option.value
      $scope.selectedOption = option
    }
  }
})()
